<h2 mat-dialog-title>Usuario bloqueado</h2>
<mat-dialog-content>
  <p class="modalText">
    {{ data.text }}
    <button
      *ngIf="isBlocked"
      class="modalBtn"
      (click)="navigateToResetPass()"
      type="button"
    >
      {{ 'hereBtn' | i18next | uppercase }}
    </button>
  </p>
  <div class="modal-container--btn-container">
    <button type="submit" class="modalCancelBtn" mat-dialog-close>
      {{ 'btnCancel' | i18next | uppercase }}
    </button>
  </div>
</mat-dialog-content>
